<template>
  <div class="order-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <el-input
        placeholder="商品名称"
        prefix-icon="el-icon-goods"
        size="small"
        v-model="searchForm.productName"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-select
        v-model="searchForm.orderStatus"
        placeholder="订单状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in orderStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="买家名称"
        prefix-icon="el-icon-user"
        size="small"
        v-model="searchForm.buyerName"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-input
        placeholder="买家手机号"
        prefix-icon="el-icon-mobile-phone"
        size="small"
        v-model="searchForm.buyerMobile"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-date-picker
        v-model="searchForm.payTimeRange"
        size="small"
        type="datetimerange"
        range-separator="至"
        start-placeholder="支付开始时间"
        end-placeholder="支付结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
      >
      </el-date-picker>
      <el-input
        placeholder="客户来源"
        prefix-icon="el-icon-connection"
        size="small"
        v-model="searchForm.customerSource"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-button type="primary" size="small" @click="query">搜索</el-button>
      <el-button size="small" @click="reset">重置</el-button>
      <el-button type="success" size="small" @click="exportData" :loading="exportLoading">
        {{ exportLoading ? '导出中...' : '导出' }}
      </el-button>
    </div>
    <div class="list" v-loading="listLoading">
      <div class="order-table">
        <div class="table-header">
          <div class="th">商品信息</div>
          <div class="th">单价(元)</div>
          <div class="th">实付金额(元)</div>
          <div class="th">买家名称</div>
          <div class="th">买家手机号</div>
          <div class="th">订单状态</div>
          <div class="th">售后状态</div>
          <div class="th">客户来源</div>
          <div class="th">操作</div>
        </div>
        <div v-if="!orderList.length" class="empty-tip">暂无订单数据</div>
        <div v-for="order in orderList" :key="order.order_no" class="order-group">
          <div class="order-sub-header">
            <span class="order-no">订单号: {{ order.order_no }}</span>
            <span class="payment-time">支付时间: {{ order.payment_time || '-' }}</span>
          </div>
          <div class="order-data-row">
            <div class="td">
              <el-tooltip :content="order.product_name || '-'" :disabled="!overflowState[`${order.order_no}_product_name`]" placement="top">
                <div class="td-ellipsis" :data-cell-key="`${order.order_no}_product_name`">{{ order.product_name || '-' }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <div class="td-ellipsis">¥{{ formatPriceYuan(order.unit_price) }}</div>
            </div>
            <div class="td">
              <div class="td-ellipsis">¥{{ formatPriceYuan(order.actual_payment) }}</div>
            </div>
            <div class="td">
              <el-tooltip :content="order.buyer_name || '-'" :disabled="!overflowState[`${order.order_no}_buyer_name`]" placement="top">
                <div class="td-ellipsis" :data-cell-key="`${order.order_no}_buyer_name`">{{ order.buyer_name || '-' }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <el-tooltip :content="order.buyer_mobile || '-'" :disabled="!overflowState[`${order.order_no}_buyer_mobile`]" placement="top">
                <div class="td-ellipsis" :data-cell-key="`${order.order_no}_buyer_mobile`">{{ order.buyer_mobile || '-' }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <el-tooltip :content="getOrderStatusText(order.order_status)" :disabled="!overflowState[`${order.order_no}_order_status`]" placement="top">
                <div class="td-ellipsis" :class="['status-tag', 'status-' + getOrderStatusType(order.order_status)]" :data-cell-key="`${order.order_no}_order_status`">{{ getOrderStatusText(order.order_status) }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <el-tooltip :content="getAfterSalesStatusText(order.after_sales_status)" :disabled="!overflowState[`${order.order_no}_after_sales_status`]" placement="top">
                <div class="td-ellipsis" :class="['status-tag', 'status-' + getAfterSalesStatusType(order.after_sales_status)]" :data-cell-key="`${order.order_no}_after_sales_status`">{{ getAfterSalesStatusText(order.after_sales_status) }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <el-tooltip :content="order.customer_source || '-'" :disabled="!overflowState[`${order.order_no}_customer_source`]" placement="top">
                <div class="td-ellipsis" :data-cell-key="`${order.order_no}_customer_source`">{{ order.customer_source || '-' }}</div>
              </el-tooltip>
            </div>
            <div class="td">
              <a class="detail-link" href="javascript:;" @click.prevent="goOrderDetail(order)">详情</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  data() {
    return {
      searchForm: {
        productName: '',
        orderStatus: '',
        buyerName: '',
        buyerMobile: '',
        payTimeRange: null,
        customerSource: ''
      },
      orderList: [],
      pages: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      exportLoading: false,
      orderStatusOptions: [],
      refundStatusOptions: [],
      overflowState: {}
    }
  },
  updated() {
    this.$nextTick(this.checkOverflow)
  },
  created() {
    this.getOrderList()
    this.fetchOrderEnums()
  },
  methods: {
    fetchOrderEnums() {
      this.$getOrderEnums().then((enums) => {
        this.orderStatusOptions = enums.order_status || []
        this.refundStatusOptions = enums.refund_status || []
      })
    },
    getOrderList() {
      this.listLoading = true
      const { productName, orderStatus, buyerName, buyerMobile, payTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/order/list?page=${this.pages}&limit=${this.limit}`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (orderStatus) url += `&order_status=${encodeURIComponent(orderStatus)}`
      if (buyerName) url += `&buyer_name=${encodeURIComponent(buyerName)}`
      if (buyerMobile) url += `&buyer_mobile=${encodeURIComponent(buyerMobile)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (payTimeRange && payTimeRange.length === 2) {
        url += `&payment_time_start=${encodeURIComponent(payTimeRange[0])}&payment_time_end=${encodeURIComponent(payTimeRange[1])}`
      }
      this.$get(url, {})
        .then((res) => {
          this.listLoading = false
          if (res.data && res.data.status === 'success' && res.data.data) {
            const d = res.data.data
            this.orderList = d.list || []
            this.total = d.total || 0
          } else {
            this.orderList = []
            this.total = 0
            this.$message.error(res.data && res.data.msg ? res.data.msg : '请求失败')
          }
        })
        .catch(() => {
          this.listLoading = false
          this.orderList = []
          this.total = 0
        })
    },
    formatPriceYuan(val) {
      if (val === undefined || val === null) return '0.00'
      const num = typeof val === 'number' ? val : parseFloat(val)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    getOrderStatusType(status) {
      const map = {
        SUCCESS: 'success',
        REFUND: 'danger',
        NOTPAY: 'warning',
        CLOSED: 'info',
        REVOKED: 'info',
        USERPAYING: 'warning',
        PAYERROR: 'danger',
        pending: 'warning',
        paid: 'success',
        completed: 'info',
        cancelled: 'info',
        refunded: 'danger'
      }
      return map[status] || 'info'
    },
    getOrderStatusText(status) {
      const opt = (this.orderStatusOptions || []).find((o) => o.value === status)
      if (opt) return opt.label
      const fallback = {
        pending: '待支付',
        paid: '已支付',
        completed: '已完成',
        cancelled: '已取消',
        refunded: '已退款',
        SUCCESS: '支付成功',
        REFUND: '转入退款',
        NOTPAY: '未支付',
        CLOSED: '已关闭',
        REVOKED: '已撤销',
        USERPAYING: '用户支付中',
        PAYERROR: '支付失败'
      }
      return fallback[status] || (status ? String(status) : '-')
    },
    getAfterSalesStatusText(status) {
      if (status === undefined || status === null || status === '') return '-'
      const opt = (this.refundStatusOptions || []).find((o) => o.value === status)
      if (opt) return opt.label
      const fallback = {
        PROCESSING: '退款处理中',
        SUCCESS: '退款成功',
        ABNORMAL: '退款异常',
        CLOSED: '退款关闭',
        NONE: '无售后',
        none: '无售后',
        applied: '申请中',
        refunded: '已退款',
        rejected: '已拒绝',
        refund_failed: '退款失败'
      }
      return fallback[status] || String(status)
    },
    getAfterSalesStatusType(status) {
      if (status === undefined || status === null || status === '') return 'default'
      const map = {
        PROCESSING: 'warning',
        SUCCESS: 'success',
        ABNORMAL: 'danger',
        CLOSED: 'info',
        NONE: 'default',
        none: 'default',
        applied: 'warning',
        refunded: 'danger',
        rejected: 'danger',
        refund_failed: 'danger'
      }
      return map[status] || 'default'
    },
    checkOverflow() {
      const els = this.$el.querySelectorAll('.td-ellipsis[data-cell-key]')
      els.forEach((el) => {
        const key = el.getAttribute('data-cell-key')
        const overflow = el.scrollWidth > el.clientWidth
        if (this.overflowState[key] !== overflow) {
          this.$set(this.overflowState, key, overflow)
        }
      })
    },
    goOrderDetail(row) {
      const orderNo = row.order_no
      this.$router.push({ path: '/order-detail', query: { order_no: orderNo } })
    },
    query() {
      this.pages = 1
      this.getOrderList()
    },
    reset() {
      this.searchForm = {
        productName: '',
        orderStatus: '',
        buyerName: '',
        buyerMobile: '',
        payTimeRange: null,
        customerSource: ''
      }
      this.pages = 1
      this.getOrderList()
    },
    handleSizeChange(val) {
      this.limit = val
      this.getOrderList()
    },
    handleCurrentChange(val) {
      this.pages = val
      this.getOrderList()
    },
    exportData() {
      this.exportLoading = true
      const { productName, orderStatus, buyerName, buyerMobile, payTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/order/export?`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (orderStatus) url += `&order_status=${encodeURIComponent(orderStatus)}`
      if (buyerName) url += `&buyer_name=${encodeURIComponent(buyerName)}`
      if (buyerMobile) url += `&buyer_mobile=${encodeURIComponent(buyerMobile)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (payTimeRange && payTimeRange.length === 2) {
        url += `&payment_time_start=${encodeURIComponent(payTimeRange[0])}&payment_time_end=${encodeURIComponent(payTimeRange[1])}`
      }
      url = url.replace(/\?&/, '?').replace(/\?$/, '') || '/v1/admin/order/export'
      this.$getFile(url, {})
        .then((res) => {
          if (res && res.status === 200 && res.data) {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const date = new Date()
            const timeStr = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `订单列表_${timeStr}.xlsx`
            a.click()
            URL.revokeObjectURL(a.href)
            this.$message.success('导出成功')
          } else {
            this.$message.error('导出失败')
          }
        })
        .catch(() => {
          this.$message.error('导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-list
  .search
    margin 20px 0
    display flex
    flex-wrap wrap
    align-items center
    gap 12px
    .el-input
      width 160px
    .el-select
      width 140px
    .el-date-editor
      width 360px
    .el-button
      margin-right 0

  .list
    margin-top 20px
    min-height 400px
    border 1px solid #e8e8e8
    border-radius 2px

  .order-table
    border-collapse collapse
    font-size 14px

  .table-header
    display flex
    background #f5f5f5
    border-bottom 1px solid #e8e8e8

  .table-header .th
    flex 1
    min-width 0
    padding 12px 16px
    text-align center
    color rgba(0, 0, 0, 0.85)
    font-weight 500

  .table-header .th:nth-child(1)
    flex 1.6
  .table-header .th:nth-child(2),
  .table-header .th:nth-child(3)
    flex 0.9
  .table-header .th:nth-child(9)
    flex 0.7

  .empty-tip
    padding 40px
    text-align center
    color #999
    font-size 14px

  .order-group
    border-bottom 1px solid #e8e8e8

  .order-sub-header
    display flex
    align-items center
    padding 10px 16px
    background #f5f5f5
    border-bottom 1px solid #e8e8e8
    font-size 13px
    color rgba(0, 0, 0, 0.65)

  .order-sub-header .order-no
    flex-shrink 0
  .order-sub-header .payment-time
    flex-shrink 0
    margin-left 24px

  .order-data-row
    display flex
    background #fff
    align-items center

  .order-data-row .td
    flex 1
    min-width 0
    padding 12px 16px
    text-align center
    color rgba(0, 0, 0, 0.65)
    border-right 1px solid #e8e8e8

  .order-data-row .td >>> .el-tooltip__trigger
    display block
    overflow hidden
  .order-data-row .td .td-ellipsis
    display block
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    width 100%

  .order-data-row .td:last-child
    border-right none

  .order-data-row .td:nth-child(1)
    flex 1.6
  .order-data-row .td:nth-child(2),
  .order-data-row .td:nth-child(3)
    flex 0.9
  .order-data-row .td:nth-child(9)
    flex 0.7

  .status-tag.status-success
    color #67C23A
  .status-tag.status-danger
    color #F56C6C
  .status-tag.status-warning
    color #E6A23C
  .status-tag.status-info
    color #909399
  .status-tag.status-default
    color rgba(0, 0, 0, 0.65)

  .detail-link
    color #1890ff
    text-decoration none
    cursor pointer
  .detail-link:hover
    color #40a9ff
    text-decoration underline

  .block
    margin-top 10px
</style>



// WEBPACK FOOTER //
// src/pages/OrderCenter/OrderList.vue